import { useTranslation } from "react-i18next";
import { SunFill, MoonFill } from "react-bootstrap-icons";
import { useTheme } from "../context/ThemeContext";
import { NavButton } from "./NavButton";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const isDark = theme === "dark";

  return (
    <NavButton
      className="nav-btn--icon"
      onClick={toggleTheme}
      aria-label={isDark ? t("theme.toggleLight") : t("theme.toggleDark")}
    >
      {isDark ? <SunFill size={16} /> : <MoonFill size={16} />}
    </NavButton>
  );
};
